import type { MessagingChannelsCopy } from './types';

export const ID: MessagingChannelsCopy = {
  title: 'Perpesanan',
  description:
    'Bicara dengan IMAI dari aplikasi chat yang sudah Anda pakai. Hubungkan sekali, lalu kirim pesan ke IMAI di sana.',
  privacy:
    'Pesan dari akun yang Anda hubungkan berjalan atas nama Anda di ruang kerja ini dan memakai kredit Anda.',
  loading: 'Memuat saluran perpesanan',
  unavailable: 'Belum tersedia',
  unavailableNote: '{channel} belum disiapkan untuk IMAI.',
  connectedBadge: 'Terhubung',
  cancel: 'Batal',

  addNumber: 'Tambahkan nomor',
  countryLabel: 'Kode negara',
  countrySearch: 'Cari negara atau kode…',
  countryEmpty: 'Negara tidak ditemukan.',
  numberLabel: 'Nomor telepon',
  continueActivation: 'Lanjutkan',
  editNumber: 'Ganti nomor',
  activateQr: 'Pindai dan tekan Kirim',
  activateHint: 'Buka {channel} lalu tekan Kirim.',
  activationBack: 'Kembali',
  activateButton: 'Buka {channel}',
  activateWaiting: 'Menunggu pesan Anda. Kedaluwarsa dalam {time}.',
  startAgain: 'Mulai lagi',
  remove: 'Hapus',
  removeAria: 'Hapus nomor telepon {number}',
  removeTitle: 'Hapus {number}?',
  removeDescription:
    'IMAI akan berhenti membalas nomor ini di iMessage dan WhatsApp. Anda bisa menambahkannya lagi kapan saja.',
  removeError: 'Nomor tidak bisa dihapus. Coba lagi.',

  errorInvalidNumber: 'Masukkan nomor telepon yang valid, termasuk kode area.',
  errorNumberTaken: 'Nomor ini sudah dipakai akun IMAI lain.',
  errorRateLimited:
    'Terlalu banyak percobaan. Tunggu sebentar, lalu coba lagi.',
  errorChannelUnavailable:
    'Opsi ini sedang tidak tersedia. Pilih opsi lainnya.',
  errorSendFailed: 'Tidak dapat memulai verifikasi. Coba lagi.',
  errorActivationExpired: 'Aktivasi ini sudah kedaluwarsa. Mulai lagi.',

  noteSlack: 'Kirim pesan ke IMAI dari ruang kerja Slack Anda.',
  noteTeams: 'Kirim pesan ke IMAI dari Microsoft Teams.',
  noteTelegram: 'Chat dengan bot IMAI di Telegram.',
  connect: 'Hubungkan',
  connectAria: 'Hubungkan {channel}',
  connectError: 'Tidak bisa mulai menghubungkan {channel}. Coba lagi.',
  connectedOn: 'Terhubung {date}',
  accountFallback: 'Akun {channel} Anda',
  installSlack: 'Tambahkan IMAI ke ruang kerja Anda',
  installTeams: 'Tambahkan IMAI ke Teams',
  openTelegram: 'Buka di Telegram',
  disconnect: 'Putuskan',
  disconnectAria: 'Putuskan {account} dari {channel}',
  disconnectError: '{channel} tidak bisa diputuskan. Coba lagi.',
  disconnectTitle: 'Putuskan {channel}?',
  disconnectDescription:
    'Pesan dari {account} tidak akan sampai ke IMAI lagi. Anda bisa menghubungkannya lagi kapan saja.',

  toastConnected: '{channel} terhubung',
  toastConnectedGeneric: 'Akun terhubung',
  toastErrorExpired: 'Proses masuk terlalu lama. Coba hubungkan lagi.',
  toastErrorInvalidState: 'Tautan masuk itu sudah tidak berlaku. Coba lagi.',
  toastErrorAccountTaken: 'Akun itu sudah terhubung ke pengguna IMAI lain.',
  toastErrorNotMember: 'Anda bukan lagi anggota ruang kerja ini.',
  toastErrorProvider: 'Proses masuk tidak selesai. Coba hubungkan lagi.',
  toastErrorGeneric: 'Akun tidak bisa dihubungkan. Coba lagi.',
};
